import * as React from "react";
import { FunctionComponent } from "react";
import PartnerLogo from "./PartnerLogo";
import { LogoSize, TranslatedPartnerLogo } from "../types";
import * as ClassNames from "classnames";

interface Props {
  className?: string;
  partnerLogos: TranslatedPartnerLogo[];
  logoSize: LogoSize;
}

const PartnerLogos: FunctionComponent<Props> = ({
  partnerLogos,
  logoSize,
  className,
}) => {
  return (
    <div className={ClassNames("PartnerLogos", className)}>
      <div className="PartnerLogos__Inner">
        {partnerLogos.map((partnerLogo) => (
          <PartnerLogo
            key={partnerLogo.id}
            partnerLogo={partnerLogo}
            size={logoSize}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnerLogos;
